/**
 * MobileTabBar — barra inferior de navegación en móvil (oculta en lg+).
 * 4 favoritos (según rol) + "Más", que abre el sidebar como drawer.
 */
import { MoreHorizontal } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { useDevEnabled } from '@/lib/useDevEnabled'
import { navItemsFor } from './navItems'

export function MobileTabBar({ onMore }) {
  const { user } = useAuth()
  const devEnabled = useDevEnabled()
  const items = navItemsFor(user?.role || 'user', devEnabled).slice(0, 4)

  const tabBase = 'flex-1 flex flex-col items-center gap-1 press'
  const tabStyle = { background: 'transparent', border: 0, padding: '4px 0', cursor: 'pointer', fontSize: 10.5, fontWeight: 700, fontFamily: 'inherit' }

  return (
    <div
      className="flex lg:hidden"
      style={{
        flexShrink: 0,
        background: '#033021',
        borderTop: '1px solid rgba(255,255,255,0.12)',
        padding: '10px 6px',
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom))',
      }}
    >
      {items.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={tabBase}
          style={({ isActive }) => ({ ...tabStyle, color: isActive ? '#C3DB5A' : 'rgba(255,255,255,0.7)' })}
        >
          {({ isActive }) => (
            <>
              <span style={{ position: 'relative' }}>
                {isActive && (
                  <span
                    aria-hidden="true"
                    style={{ position: 'absolute', top: -13, left: '50%', transform: 'translateX(-50%)', width: 28, height: 3, borderRadius: '0 0 3px 3px', background: '#C3DB5A' }}
                  />
                )}
                <Icon size={22} strokeWidth={2} />
              </span>
              <span className="whitespace-nowrap">{label}</span>
            </>
          )}
        </NavLink>
      ))}
      <button type="button" onClick={onMore} aria-label="Más opciones" className={tabBase} style={{ ...tabStyle, color: 'rgba(255,255,255,0.7)' }}>
        <MoreHorizontal size={22} strokeWidth={2} />
        <span>Más</span>
      </button>
    </div>
  )
}
